module.exports = __webpack_public_path__ + "img/vvv.572287c7.png";